import { Vue, Component } from 'vue-property-decorator'
import { PageDTO, PageContainerDTO, PageElementsDTO } from '@/data/dto/page.dto'

@Component
export default class PersonaPageMixin extends Vue {
  get getPersonaPageAll(): PageDTO | null {
    return (this as any).personaPageStore.all
  }

  getContainer(index: number): PageContainerDTO | undefined {
    return this.getPersonaPageAll?.data?.containers[index]
  }

  getElement(containerIndex: number, elementIndex: number): PageElementsDTO | undefined {
    return this.getContainer(containerIndex)?.elements[elementIndex]
  }

  getElementTitle(containerIndex: number, elementIndex: number): string {
    return this.getElement(containerIndex, elementIndex)?.title || ''
  }

  getElementText(containerIndex: number, elementIndex: number): string {
    return this.getElement(containerIndex, elementIndex)?.text || ''
  }

  getElementMedia(containerIndex: number, elementIndex: number): string {
    return this.getElement(containerIndex, elementIndex)?.media || ''
  }
}
